<template>
  <div>
    <div class="honour-btn" @click="showCert = true" v-if="showHonourBtn">
      <a-button type='link'>《荣耀时刻》</a-button>
    </div>
    <div class="certModal" v-if="showCert" @click.self="showCert = false">
      <div class="certImg">
        <img :src="require('@/assets/images/certificate.png')">
        <div class="company"><span>{{honourMsg.shopName}}</span></div>
        <div class="certMessage">恭喜您在商家荣耀时刻{{honourMsg.selectionCycle}}评选，“{{honourMsg.rankingListName}}”排行榜中位列第<span class="rank">{{honourMsg.ranking}}</span>名</div>
        <div class="certTitle">荣获<span>“{{honourMsg.honourName}}”</span>称号</div>
        <div class="issue">
          <span>孩子王儿童用品股份有限公司</span>
          <span>{{certDate}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { Button } from 'ant-design-vue'
import _ from 'lodash'
export default {
  data () {
    return {
      showCert:false
    }
  },
  components: {
    [Button.name]: Button
  },
  computed: {
    honourMsg() {
      let honourMsg = _.get(this.$store.state.popHome.honourTimeInfo, 'honour', {})
      return honourMsg ? honourMsg : {}
    },
    showHonourBtn() {
      let newDate = moment(moment(new Date()).format('YYYY-MM-DD')).unix()
      let { honourTimeInfo } = this.$store.state.popHome
      if (_.get(honourTimeInfo, ['honour', 'honourEndDate'])) {
        return moment(honourTimeInfo.honour.honourEndDate).unix() >= newDate
      } else {
        return false
      }
    },
    certDate() {
      let { honourTimeInfo } = this.$store.state.popHome
      if (_.get(honourTimeInfo, ['honour', 'publishDate'])) {
        let certDateArray = honourTimeInfo.honour.publishDate.split(' ')[0].split('-')
        return certDateArray[0] + '年' + certDateArray[1] + '月' + certDateArray[2] + '日'
      } else {
        return ''
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.certModal {
  position: fixed;
  left: 0;
  top: 0;
  background: rgba(191, 191, 191,0.5);
  width: 100%;
  height: 100%;
  z-index: 801;
  display: flex;
  align-items: center;
  justify-content: center;
  .certImg {
    width: 620px;
    height: 440px;
    position: relative;
    display: flex;
    flex-direction: column;
    font-size: 14px;
    color: #333333;
    .company {
      font-family: MicrosoftYaHei-Bold;
      font-weight: bold;
      font-size: 16px;
      z-index: 802;
      margin-top: 174px;
      margin-left: 108px;
      width: min-content;
      span {
        padding-bottom: 3px;
        border-bottom: 1px solid black;
      }
    }
    .certMessage {
      z-index: 802;
      margin-top: 13px;
      margin-left: 108px;
      width: 413px;
      white-space: normal;
      text-align: left;
      line-height: 22px;
      font-family: MicrosoftYaHei;
      .rank {
        color: #EB3423;
      }
    }
    .certTitle {
      margin-top: 20px;
      margin-left: 108px;
      z-index: 802;
      width: min-content;
      span {
        font-family: MicrosoftYaHei-Bold;
        font-size: 24px;
        color: #EB3423;
        line-height: 22px;
        font-weight: bold;;
      }
    }
    .issue {
      z-index: 802;
      position: absolute;
      right: 99px;
      bottom: 74px;
      display: flex;
      flex-direction: column;
      align-items: center;
      font-family: MicrosoftYaHei;
      font-size: 12px;
      line-height: 22px;
    }
    img {
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
    }
  }
}

</style>
